import React, { useState } from 'react';

function SolicitudPackagingPage() {
  const [form, setForm] = useState({
    nombreComercial: '',
    codigoAS400: '',
    descripcion: '',
    tipo: '',
    formato: '',
    material: '',
    color: '',
    medidas: '',
  });

  const [error, setError] = useState('');

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    for (const key in form) {
      if (!form[key].trim()) {
        setError(`Por favor completa el campo ${key}`);
        return;
      }
    }
    setError('');
    alert('Formulario enviado! (aquí implementa la lógica real)');
    setForm({
      nombreComercial: '',
      codigoAS400: '',
      descripcion: '',
      tipo: '',
      formato: '',
      material: '',
      color: '',
      medidas: '',
    });
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Solicitud de Packaging</h1>
        <form className="formulario-packaging" onSubmit={handleSubmit} noValidate>
          {error && <p className="error">{error}</p>}

          <label>
            Nombre comercial:
            <input
              type="text"
              name="nombreComercial"
              value={form.nombreComercial}
              onChange={handleChange}
              maxLength={50}
              autoComplete="off"
              required
              className="input-corto"
            />
          </label>

          <label>
            Código AS400:
            <input
              type="text"
              name="codigoAS400"
              value={form.codigoAS400}
              onChange={handleChange}
              maxLength={10}
              autoComplete="off"
              required
              className="input-corto"
            />
          </label>

          <label>
            Descripción:
            <input
              type="text"
              name="descripcion"
              value={form.descripcion}
              onChange={handleChange}
              autoComplete="off"
              required
              className="input-largo"
            />
          </label>

          <label>
            Tipo:
            <input
              type="text"
              name="tipo"
              value={form.tipo}
              onChange={handleChange}
              maxLength={20}
              autoComplete="off"
              required
              className="input-medio"
            />
          </label>

          <label>
            Formato:
            <input
              type="text"
              name="formato"
              value={form.formato}
              onChange={handleChange}
              autoComplete="off"
              required
              className="input-medio"
            />
          </label>

          <label>
            Material:
            <input
              type="text"
              name="material"
              value={form.material}
              onChange={handleChange}
              autoComplete="off"
              required
              className="input-medio"
            />
          </label>

          <label>
            Color:
            <input
              type="text"
              name="color"
              value={form.color}
              onChange={handleChange}
              autoComplete="off"
              required
              className="input-medio"
            />
          </label>

          <label>
            Medidas (Alto x Ancho x Largo):
            <input
              type="text"
              name="medidas"
              value={form.medidas}
              onChange={handleChange}
              autoComplete="off"
              required
              className="input-largo"
            />
          </label>

          <button type="submit" className="btn-primario">Enviar</button>
        </form>
      </header>
    </div>
  );
}

export default SolicitudPackagingPage;
